import { BaseComponent } from '../../base-component';
import { EventTracking } from './event-tracking';
import { HtmlTracking } from './html-tracking';
import { ViewTracking } from './view-tracking';
import { VisibilityTracking } from './visibility-tracking';
import { VariationTrackingDataProvider } from './variation-tracking-data-provider';
import { trackView } from '@otto-ec/nexus-registry/pdp/tracking';
import { FT5_TRACKING_RELOAD } from '../../constants';

export class TrackingComponent extends BaseComponent {
    public rootSelector = '.js_pdp_tracking_component';

    constructor(
        private eventTracking: EventTracking,
        private viewTracking: ViewTracking,
        private htmlTracking: HtmlTracking,
        private visibilityTracking: VisibilityTracking,
        private provider: VariationTrackingDataProvider
    ) {
        super();
    }

    public async init(): Promise<void> {
        o_global.eventQBus.on(FT5_TRACKING_RELOAD, (variationId: string) => {
            this.provider.set(variationId);
        });
        this.viewTracking.init();
        this.eventTracking.init();
        this.htmlTracking.init();
    }

    public async onHtmlLoaded(): Promise<void> {
        this.htmlTracking.onHtmlLoaded();

        const { dataContainer, features } = this.provider.getVariationTrackingData();
        trackView(dataContainer, features);

        this.visibilityTracking.onHtmlLoaded();
    }
}
